import {
    GamefeedRawData,
    IllustratorRawData,
    isGamefeedRawData,
} from '../schema/types.ts'

export function RemoveBadSprayPoints(
    data: GamefeedRawData[] | IllustratorRawData[]
) {
    return data.filter((d) => d.hc_x_ft && d.hc_y_ft) as
        | GamefeedRawData[]
        | IllustratorRawData[]
}

export function RemoveBadPitchPoints(
    data: GamefeedRawData[] | IllustratorRawData[]
): GamefeedRawData[] | IllustratorRawData[] {
    return data.filter(
        (d) =>
            (d.px &&
                d.pz &&
                d.pitch_type &&
                d.pitch_type !== null &&
                d.pitch_type !== '') ||
            // TODO: Is this what we want? Just copying the way it's been done.
            (!isGamefeedRawData(d) && d.is_pa === '1')
    ) as GamefeedRawData[] | IllustratorRawData[]
}
